import React, { useState } from "react";
import axios from "axios";
import {
  TextField,
  Autocomplete,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import useSharedLink from "../../../../src/SharedLink";
import { xorDecrypt } from "../../../encrypt";
import axiosInstance from "../../../api/axiosInstance";

// Define options for dropdown fields
const genderOptions = [
  { label: "Male" },
  { label: "Female" },
  { label: "Other" },
];

const AddSubscriber = () => {
  const sharedLink = useSharedLink();

  // State variables for form fields
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    dateOfBirth: null,
    phoneNumber: "",
    gender: null,
    address: "",
  });

  // Handler for form field changes
  const handleInputChange = (field) => (event, newValue) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: newValue !== undefined ? newValue : event.target.value,
    }));
  };

  // Handler for form submission
  const handleSubmit = async () => {
    const formattedData = {
      ...formData,
      dateOfBirth: formData.dateOfBirth
        ? formData.dateOfBirth.format("YYYY-MM-DD")
        : "",
      role: "Subscriber",
      lastUpdatedBy: xorDecrypt(localStorage.getItem("username")),
      enteredBy: xorDecrypt(localStorage.getItem("username")),
      lastUpdatedTime: new Date().toISOString(),
      enteredTime: new Date().toISOString(),
      gender: formData.gender ? formData.gender.label : "", // Extract gender as string
    };

    //console.log("Submitting Data: ", formattedData);

    try {
      const response = await axiosInstance.post(`${sharedLink}/api/abanotes/addsubscriber`, formattedData, {
        withCredentials: true,
      });
      //console.log("Response: ", response.data);
    } catch (error) {
      console.error("Error submitting data: ", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "16px",
        marginTop: "100px",
        backdropFilter: "blur(10px)" 
      }}
    >
      <Box
        sx={{ display: "flex", justifyContent: "center", width: "100%", mt: 4 }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Add Subscriber
        </Typography>
      </Box>

      {/* Name text field */}
      <TextField
        label={
          <span>
            Name<span style={{ color: "red" }}>*</span>
          </span>
        }
        variant="outlined"
        value={formData.name}
        className="animated-input"
        onChange={handleInputChange("name")}
        fullWidth
        margin="normal"
        InputLabelProps={{ style: { color: "black" } }} // Ensuring label is visible
        sx={{ flex: "1 1 48%" }}
      />

      {/* Date of Birth date picker */}
      <DatePicker
        label={
          <span>
            Date of Birth<span style={{ color: "red" }}>*</span>
          </span>
        }
        value={formData.dateOfBirth}
        onChange={(newValue) => {
          setFormData((prevData) => ({
            ...prevData,
            dateOfBirth: newValue,
          }));
        }}
        className="animated-input"
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            margin="normal"
            InputLabelProps={{ style: { color: "black" } }} // Ensuring label is visible
          />
        )}
        sx={{ flex: "1 1 48%", mt: 2 }}
      />

      {/* Email text field */}
      <TextField
        label={
          <span>
            Email<span style={{ color: "red" }}>*</span>
          </span>
        }
        variant="outlined"
        value={formData.email}
        className="animated-input"
        onChange={handleInputChange("email")}
        fullWidth
        margin="normal"
        InputLabelProps={{ style: { color: "black" } }} // Ensuring label is visible
        sx={{ flex: "1 1 48%" }}
      />

      {/* Phone Number text field */}
      <TextField
        label={
          <span>
            Phone Number<span style={{ color: "red" }}>*</span>
          </span>
        }
        variant="outlined"
        value={formData.phoneNumber}
        className="animated-input"
        onChange={handleInputChange("phoneNumber")}
        fullWidth
        margin="normal"
        InputLabelProps={{ style: { color: "black" } }} // Ensuring label is visible
        sx={{ flex: "1 1 48%" }}
      />

      {/* Gender dropdown */}
      <Autocomplete
        fullWidth
        options={genderOptions}
        getOptionLabel={(option) => option.label}
        className="animated-input"
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label={
              <span>
                Gender<span style={{ color: "red" }}>*</span>
              </span>
            }
            variant="outlined"
            margin="normal"
            InputLabelProps={{ style: { color: "black" } }} // Ensuring label is visible
          />
        )}
        value={formData.gender}
        onChange={handleInputChange("gender")}
        sx={{ flex: "1 1 48%" }}
      />

      {/* Address text field */}
      <TextField
        label={
          <span>
            Address<span style={{ color: "red" }}>*</span>
          </span>
        }
        variant="outlined"
        value={formData.address}
        className="animated-input"
        onChange={handleInputChange("address")}
        fullWidth
        margin="normal"
        InputLabelProps={{ style: { color: "black" } }} // Ensuring label is visible
        sx={{ flex: "1 1 48%" }}
      />

      {/* Submit button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          mt: 2,
        }}
      >
        <Button
          type="button"
          variant="contained"
          className="animated-input"
          onClick={handleSubmit}
          sx={{
            backgroundColor: "#3A57E8",
            color: "white",
            fontWeight: "bold",
            borderRadius: "20px",
            padding: "8px 16px",
            mt: 2,

            "&:hover": {
              backgroundColor: "#0059b2",
            },
          }}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default AddSubscriber;
